import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-list-with-image',
  templateUrl: './list-with-image.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./list-with-image.component.scss']
})
export class ListWithImageComponent implements OnInit {

  @Input() items:string[];
  @Input() tileList:string;
  @Input() descriptionList:string;
  @Input() imgListPath:string;
  @Input() routerListButton:string;
  @Input() buttonListText:string;

  constructor() { }

  ngOnInit(): void {
  }

}
